<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Création de courrier personnalisé </div>
        <div class="modal-body">
            <form [formGroup]="courrierForm" (ngSubmit)="saveCourrier()" *ngIf="courrierForm"
                class="courrier-card-content">
                <frg-form-input label="Titre du courrier" class="input-edit-mode" id="titre" type="text"
                    [formGroup]="courrierForm" [control]="courrierForm.get('titre')">
                </frg-form-input>
                <div class="col-container">
                    <div class="col col-1">
                        <div class="quill-container extend-quill">
                            <!-- Je ne fais pas la conversion à Froala ici car ce fragment semble inutilisé dans l'application.
                            Voir pour le supprimer. -->
                            <quill-editor appQuillRemoveButtons [buttonsToRemove]="['ql-image', 'ql-video']" title="" class="quill-editor" #quillDrop theme="snow" classes="test" cdkDropList
                                (cdkDropListDropped)="dropped($event)" id="quillDrop" cdkDropListConnectedTo="table2"
                                placeholder="Ajouter du texte ici...">
                            </quill-editor>
                        </div>
                    </div>
                    <div class="col col-2">
                        <div class="buttons-table">
                            <div class="icon-button tag" title="Tags" (mousedown)="changeTable('tag')"></div>
                            <div class="icon-button glossaire" title="Glossaire" (mousedown)="changeTable('glossaire')">
                            </div>
                            <div class="icon-button pense-bete" title="Pense-bête"
                                (mousedown)="changeTable('penseBete')"></div>
                            <div class="icon-button maquette" title="Maquettes" (mousedown)="changeTable('maquette')">
                            </div>
                            <div class="icon-button critere" title="Critères" (mousedown)="changeTable('critere')">
                            </div>
                            <div class="icon-button element-dossier-patient" title="Dossier patient"
                                (mousedown)="changeTable('dossierPatient')"></div>
                            <div class="icon-button liste-courrier-type" title="Courriers personnalisés"
                                (mousedown)="changeTable('courrierPerso')"></div>
                            <div class="icon-button medicaments-saisie-libre" title="Médicaments saisie libre"
                                (mousedown)="changeTable('medicamentLibre')"></div>
                        </div>
                        <frg-search-input #searchInput (search)="filterAutoreplaceList($event)"></frg-search-input>
                        <frg-table #table2 [keysBody]="autoReplaceBodyTable" [keysColumn]="autoReplaceColumnTable"
                            class="table" [dragDrop]="true" idDropTable="table2" idConnectedTable="quillDrop">
                        </frg-table>
                    </div>
                </div>
                <div class="button-wrapper">
                    <frg-button [type]="'reset'" (activated)="closeAddEditModal()"
                        [backgroundColor]="'var(--darkest-primary)'">Annuler
                    </frg-button>
                    <frg-button id="subButton" (mousedown)="saveCourrier()" [type]="'button'">Enregistrer le courrier
                    </frg-button>
                </div>
                <div class="error-container group-error" [ngClass]="{'no-height': !isError}">
                    {{errorMessage}}
                </div>
            </form>
        </div>
    </div>
    <div class="modal-background"></div>